import { IViewAccelerationPerf } from '../../../../dataAcceleration/serverApi/types/IViewAccelerationPerf';
import { IViewAccelerationStatus } from '../../../../dataAcceleration/serverApi/types/IViewAccelerationStatus';
import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../ts/ServerApi/types/IGetItemsResult';
import { IViewUsageInfo } from '../../../../ts/ServerApi/types/IUsageInfo';
import { IView } from '../../../../ts/ServerApi/types/IView';

export interface IGetWorkbookAccelerationsResult extends IGetItemsResult {
  views?: IView[];
  maxStats?: IViewUsageInfo;
  viewAccelerationPerfs?: IViewAccelerationPerf[];
  viewAccelerationStatus?: IViewAccelerationStatus[];
}

export class GetWorkbookAccelerationsRequest extends Request<IGetItemsParams, IGetWorkbookAccelerationsResult> {
  constructor(params: IGetItemsParams) {
    super('getWorkbookAccelerations', params);
  }
}
